import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { StackedBarChartRestItem } from '../horizontal-stacked-bar-chart.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-horizontal-stacked-bar-tooltip-item',
  templateUrl: './horizontal-stacked-bar-tooltip-item.component.html',
  imports: [CommonModule],
})
export class HorizontalStackedBarTooltipItemComponent {
  @Input()
  item!: StackedBarChartRestItem;
}
